import React from 'react';
import { FacebookSettings } from '../../facebook/components/FacebookSettings';
import { useIsFacebookEnabled } from '../../social-posting/hooks/useIsFacebookEnabled';
import { useIsInstagramEnabled } from '../../social-posting/hooks/useIsInstagramEnabled';
import { useIsYouTubeEnabled } from '../../social-posting/hooks/useIsYouTubeEnabled';
import { InstagramSettings } from '../../instagram/components/InstagramSettings';
import { SocialMediaIntegrationBanner } from '../components/SocialMediaIntegrationBanner';
import { YouTubeSettings } from '../../youtube/components/YouTubeSettings';

export const SocialMediaIntegrations = () => {
  const { isFacebookEnabled } = useIsFacebookEnabled();
  const { isInstagramEnabled } = useIsInstagramEnabled();
  const { isYouTubeEnabled } = useIsYouTubeEnabled();

  return (
    <div>
      <div className="integrations__container">
        {(isFacebookEnabled || isInstagramEnabled || isYouTubeEnabled) && (
          <SocialMediaIntegrationBanner />
        )}
        {isFacebookEnabled && <FacebookSettings />}
        {isInstagramEnabled && <InstagramSettings />}
        {isYouTubeEnabled && <YouTubeSettings />}
      </div>
    </div>
  );
};
